'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './memberFee.routes.js';
import MemFeeListCtrl from './list/list.controller.js';
import MemFeeViewCtrl from './view/view.controller.js';
import MemFeeFormCtrl from './form/form.controller.js';
import MemFeeAmtModalSvc from './amountModal/amountModal.service.js';

export default angular.module('georgeApp.memberFee',
  [uiRouter])
  .config(routing)
  .controller('MemFeeListCtrl', MemFeeListCtrl)
  .controller('MemFeeViewCtrl', MemFeeViewCtrl)
  .controller('MemFeeFormCtrl', MemFeeFormCtrl)
  .factory('MemFeeAmtModalSvc', MemFeeAmtModalSvc)
  .name;
